<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          AddCo
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img
            :src="imgUrl"
            fluid
            alt="Reset password"
          /> -->
          <!-- <vuexy-logo :size="200"/> -->
          <img src="/logo-new.png" alt="Logo" style="width: 10rem; height: 10rem;">
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Reset password--></img>
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title v-if="!resetSuccess" class="mb-1">
            {{ $t('message.reset_password_title') }}
          </b-card-title>
          <b-card-text v-if="!resetSuccess" class="mb-2">
            {{ $t('message.reset_password_description') }}
          </b-card-text>

          <!-- Success message -->
          <div v-if="resetSuccess" class="text-center mb-2">
            <div class="mb-2">
              <feather-icon
                icon="CheckCircleIcon"
                size="64"
                class="text-success"
              />
            </div>
            <b-card-title class="mb-1 text-success">
              {{ $t('message.password_updated_success_title') }}
            </b-card-title>
            <b-card-text class="mb-2">
              {{ $t('message.password_updated_success_description') }}
            </b-card-text>
          </div>

          <!-- form -->
          <validation-observer v-if="!resetSuccess" ref="simpleRules">
            <b-form
              class="auth-reset-password-form mt-2"
              method="POST"
              @submit.prevent="validationForm"
            >

              <!-- verification code -->
              <b-form-group
                :label="$t('message.verification_code')"
                label-for="verification-code"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('message.verification_code')"
                  rules="required"
                >
                  <b-form-input
                    id="verification-code"
                    v-model="verificationCode"
                    :state="errors.length > 0 ? false : null"
                    name="verification-code"
                    :placeholder="$t('message.enter_code_placeholder')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password requirements -->
              <b-form-group>
                <label class="mb-1">{{ $t('message.password_requirements_title') }}</label>
                <div class="password-requirements">
                  <div
                    v-for="req in requirements"
                    :key="req.key"
                    class="requirement-item"
                    :class="req.met ? 'requirement-met' : 'requirement-unmet'"
                  >
                    <feather-icon
                      :icon="req.met ? 'CheckIcon' : 'XIcon'"
                      size="16"
                      class="mr-50"
                    />
                    <span>{{ req.text }}</span>
                  </div>
                </div>
              </b-form-group>

              <!-- password -->
              <b-form-group
                :label="$t('message.New_Password')"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('message.New_Password')"
                  vid="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                :label="$t('message.confirm_password')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('message.confirm_password')"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="primary"
                :disabled="isSubmitting || !allRequirementsMet || !passwordsMatch"
              >
                <b-spinner v-if="isSubmitting" small class="mr-50" />
                <span>{{ isSubmitting ? $t('message.processing') : $t('message.set_new_password') }}</span>
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('message.back_to_login') }}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Reset password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { BRow, BCol, BCardTitle, BCardText, BForm, BFormGroup, BInputGroup, BInputGroupAppend, BLink, BFormInput, BButton, BImg, BSpinner } from 'bootstrap-vue'
import { required } from '@validations'
import { passwordRequirements } from '@core/utils/validations/validators'
import { useCognito } from '@/views/habit/awsCognito'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n'

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      verificationCode: '',
      cPassword: '',
      password: '',
      isSubmitting: false,
      resetSuccess: false,
      sideImg: require('@/assets/images/pages/reset-password-v2.svg'),
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  mounted() {
    // Set locale based on browser language
    const locale = window.navigator.language?.startsWith('es') ? 'es' : 'en'
    i18n.locale = locale
    localize(locale)

    // Get email from query params if available
    if (this.$route.query.email) {
      this.userEmail = this.$route.query.email
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/reset-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    requirements() {
      const pwd = this.password || ''
      return [
        {
          key: 'length',
          met: passwordRequirements.length(pwd),
          text: i18n.t('message.password_req_length')
        },
        {
          key: 'uppercase',
          met: passwordRequirements.uppercase(pwd),
          text: i18n.t('message.password_req_uppercase')
        },
        {
          key: 'number',
          met: passwordRequirements.number(pwd),
          text: i18n.t('message.password_req_number')
        },
        {
          key: 'symbol',
          met: passwordRequirements.symbol(pwd),
          text: i18n.t('message.password_req_symbol')
        }
      ]
    },
    allRequirementsMet() {
      return this.requirements.every(req => req.met)
    },
    passwordsMatch() {
      return this.password === this.cPassword && this.password.length > 0
    }
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    async validationForm() {
      const success = await this.$refs.simpleRules.validate()
      if (!success) return

      if (!this.userEmail) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('message.email_required_reset'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        this.$router.push({ name: 'auth-forgot-password' })
        return
      }

      this.isSubmitting = true
      const { confirmForgotPassword } = useCognito()

      try {
        await confirmForgotPassword(this.userEmail, this.verificationCode, this.password)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('message.password_updated_success_title'),
            icon: 'EditIcon',
            variant: 'success',
          },
        })

        this.password = ''
        this.cPassword = ''
        this.verificationCode = ''
        this.resetSuccess = true
      } catch (error) {
        console.error(error)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message || i18n.t('message.error_updating_password'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isSubmitting = false
      }
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.password-requirements {
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.357rem;
  margin-bottom: 1rem;
}

.requirement-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
}

.requirement-item:last-child {
  margin-bottom: 0;
}

.requirement-unmet {
  color: #ea5455;
}

.requirement-unmet svg {
  color: #ea5455;
}

.requirement-met {
  color: #28c76f;
}

.requirement-met svg {
  color: #28c76f;
}
</style>
